module.exports = __webpack_public_path__ + "img/filete_de_pescado_2.b73e49aa.jpeg";